module.exports = __webpack_public_path__ + "img/Fuhro_Souto@2x.052bd456.png";